"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Remove leading hash from a string
function fromHex(value) {
  return value ? value.substring(1) : '';
}

var _default = fromHex;
exports["default"] = _default;